import { useState, useEffect } from 'react';
import Axios from 'axios';

const useFetch = (endpoints, { query, tab, page, sort, filters }) => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (query || filters || sort || tab) {
        const params = {};

        if (query) {
          params.q = query;
        } else {
          params.q = ' ';
        }

        if (tab) {
          params.tab = tab.value;
        }
        if (page) {
          params.pg = page;
        }

        if (sort) {
          params.s = sort;
        }

        if (filters) {
          Object.keys(filters).forEach(key => {
            params[key] = filters[key];
          });
        }
        try {
          setLoading(true);
          const { data } = await Axios({
            method: 'POST',
            url: endpoints[tab.value],
            data: params
          });
          setResults(data);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      } else {
        setResults({});
      }
    };

    if (!!query && query.length >= 2 && tab) {
      fetchData();
    }
  }, [query, tab, page, sort, filters]);

  return { results, loading };
};

export default useFetch;
